import type { SortState } from '../../claim-history/simple-table/use-sort-hook'
import type { UseQueryResult } from '@tanstack/react-query'

import { useQuery } from '@tanstack/react-query'

import http from '../../../lib/http'

export interface Response {
  rows: Todos[]
  total: number
}

export interface Todos extends Record<string, unknown> {
  id: string
  description: string
  patientName: string
  patientId: string
  assigneeName: string
  assigneeId: string[]
  dueDate: string
  itemId: string
  path: string
  status: string
  urgent: boolean
  organization: string
  clientName: string
  trend: string
  priority: string
  createdAt: string
}

interface Filter {
  scope: 'mine' | 'all'
  patientId?: string
  clientName?: string
}

export function useTodos (filter: Filter, sort: SortState<Todos>): UseQueryResult<Response, unknown> {
  return useQuery({
    queryKey: [ 'todos', sort, filter ],
    async queryFn () {
      const sortQP = {
        field: sort.field as string,
        dir: sort.direction
      }
      const qp = new URLSearchParams({ ...sortQP, ...filter, opensearch: 'true' })

      return await http.getRequest<Todos[]>(`/todos?${qp.toString()}`, {})
    },
    refetchOnWindowFocus: false
  })
}
